import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';
import { connect } from 'react-redux';

// IMPORTANT!!!! -  MAKE SURE TO ADD YOUR KEY TO mapConfigResponse.js
export default function connectWithExperiments(experimentKeys) {
  function mapStateToProps(state) {
    return pick(get(state, 'config.autoupdate'), experimentKeys);
  }

  if (!isEmpty(experimentKeys)) {
    return connect(mapStateToProps);
  }

  throw new Error(
    '`connectWithExperiments` must be passed an array of experiment keys',
  );
}
